"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var matching_1 = require("../../utils/matching");
var SearchBolder = /** @class */ (function (_super) {
    __extends(SearchBolder, _super);
    function SearchBolder(props) {
        var _this = _super.call(this, props) || this;
        _this.replaceWithBold = _this.replaceWithBold.bind(_this);
        return _this;
    }
    SearchBolder.prototype.replaceWithBold = function () {
        if (!this.props.searchText) {
            return this.props.text;
        }
        var regex = matching_1.MatchingUtil.getRegExp(this.props.searchText, true, true, true);
        var splits = this.props.text.split(regex);
        var results = [];
        for (var i = 0; i < splits.length; i++) {
            if (i % 2) {
                results.push(React.createElement("b", { key: i }, splits[i]));
            }
            else {
                results.push(splits[i]);
            }
        }
        return results;
    };
    SearchBolder.prototype.render = function () {
        return React.createElement("span", null, this.replaceWithBold());
    };
    return SearchBolder;
}(React.PureComponent));
exports.default = SearchBolder;
